/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Sort_OrderInputs */

const en_reference_field_sort_order = /** @type {(inputs: Reference_Field_Sort_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort order`)
};

/**
* | output |
* | --- |
* | "Sort order" |
*
* @param {Reference_Field_Sort_OrderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_sort_order = /** @type {((inputs?: Reference_Field_Sort_OrderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Sort_OrderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_sort_order(inputs)
});